import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/auth/auth.service';
import { BiometricService } from '../services/capacitor-biometric.class';
import { BiometryError } from '@aparajita/capacitor-biometric-auth';
import { CommonPin } from '../common-pin/common-pin';

@Component({
  selector: 'modal-confirm-pin-component',
  templateUrl: './modal-confirm-pin.component.html',
  styleUrls: ['./modal-confirm-pin.component.scss']
})
export class ModalConfirmPinComponent extends CommonPin implements AfterViewInit {
  isLoading: boolean = false;
  @ViewChild("pinInput")
  pinInputControl!: ElementRef;
  wrongPin: boolean = false;
  smthWrong: boolean = false;

  pin: string = "";

  get contains4ch(): boolean {
    return this.pin.length == 4;
  }

  constructor(public modalCtrl: ModalController,
    public biometricService: BiometricService,
    private authService: AuthService,
    private router: Router,
    private el: ElementRef,
  ) {
    super(biometricService,modalCtrl);
  }

  ngAfterViewInit(): void {
    if (this.enabledBio && !this.hideBio) {
      // Biometrics will run automatically, so do NOT focus the PIN input.
      // Focusing pops the Android soft keyboard, which shrinks the WebView
      // (adjustResize); when the biometric prompt then dismisses the modal the
      // WebView fails to restore to full height and the bottom of the screen
      // stays black. The user can still tap the field to type a PIN if they
      // cancel biometrics.
      this.startBioAfterPresent();
      return;
    }
    setTimeout(() => this.pinInputControl?.nativeElement?.focus(), 2);
  }

  /**
   * Trigger biometrics once the modal's enter animation has finished.
   *
   * The app forces `mode: 'ios'` globally, so modals use the iOS card
   * presentation; dismissing mid-animation (a fast Face ID / face-auth success)
   * interrupts that transition, so we wait for `ionModalDidPresent` first.
   *
   * `ionModalDidPresent` is a one-shot event, so the listener must be attached
   * before it can fire — otherwise the promise never resolves and biometrics is
   * silently dead. We attach synchronously here (no `await`/`setTimeout` gap):
   * this runs during the modal's mount, before the enter animation starts, so
   * the event cannot have fired yet. As a safety net, if the host modal is
   * missing or has already begun presenting (Ionic removes the `overlay-hidden`
   * class the moment the enter animation starts), we prompt immediately rather
   * than wait for an event that will never come.
   */
  private startBioAfterPresent(): void {
    const modalEl = this.el.nativeElement.closest('ion-modal') as HTMLElement | null;

    if (!modalEl || !modalEl.classList.contains('overlay-hidden')) {
      this.checkBio();
      return;
    }

    modalEl.addEventListener('ionModalDidPresent', () => this.checkBio(), { once: true });
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkPin() {
    this.authService.getUserAttributes((err: any) => {
      //TODO Add correct notification
      this.smthWrong = true;
      console.log(err?.message || JSON.stringify(err));
    }
      , (res: any) => {
        if (res?.find((el: any) => el.Name == 'custom:pin' && el.Value == this.pin)) {
          return this.modalCtrl.dismiss(true, 'confirm');
        } else {
          this.wrongPin = true;
          this.smthWrong = false;
          this.pin = '';
        }
        return;
      });
  }

  cancel() {
    return this.modalCtrl.dismiss(false, 'cancel');
  }

  onChange() {
    if (!this.contains4ch) return;
    this.smthWrong = false;
    this.checkPin();
  }

  forgotPinClicked() {
    this.router.navigate(["dashboard/remind-pin"]);
    this.modalCtrl.dismiss(false, 'cancel');
  }
}